import React from 'react';

import { ModalFormSection, ModalV2 } from 'components/common/modals';

import { useEmailTemplatesOperations } from 'hooks/emailTemplates';
import EmailTemplatesForm from './EmailTemplatesForm';

const EmailTemplatesModal = ({ isOpen, onClose, onSubmit }) => {
  const { emailTemplates } = useEmailTemplatesOperations();

  return (
    <ModalV2
      id="select-template"
      title="Send Email Template"
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
    >
      <ModalFormSection>
        <EmailTemplatesForm
          templates={emailTemplates}
          isLoading={false}
          onSubmit={onSubmit}
          onClose={onClose}
        />
      </ModalFormSection>
    </ModalV2>
  );
};

export default EmailTemplatesModal;
